module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": _vm.showmenu_bar,
      "index": "10"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('about.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[0]),
      expression: "imglist[0]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n           " + _vm._s(_vm.$t('about.text4')) + "\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n           " + _vm._s(_vm.$t('about.text5')) + "\n         ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('ul', {
    staticClass: "img_list clearfix"
  }, [_c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Crusoe Mao")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v(_vm._s(_vm.$t('about.text6')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Frederick Umminger")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v(_vm._s(_vm.$t('about.text7')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Brian Watson")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v(_vm._s(_vm.$t('about.text7')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[5]),
      expression: "imglist[5]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Joyce Yang")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v(_vm._s(_vm.$t('about.text8')))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[7]),
      expression: "imglist[7]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-bottom": "2.26rem"
    },
    attrs: {
      "to": "/join"
    }
  }, [_vm._v(_vm._s(_vm.$t('about.text10')))])], 1)])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Tim Liang")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v("CTO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ca07096"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about.vue
// module id = 99
// module chunks = 0